const methods = ['cash', 'mobile_money', 'bank_transfer', 'card']
const labels = { cash: 'Cash', mobile_money: 'Mobile Money', bank_transfer: 'Bank Transfer', card: 'Card' }
const colors = { cash: 'bg-green-500', mobile_money: 'bg-blue-500', bank_transfer: 'bg-purple-500', card: 'bg-yellow-500' }
const textColors = { cash: 'text-green-600 dark:text-green-400', mobile_money: 'text-blue-600 dark:text-blue-400', bank_transfer: 'text-purple-600 dark:text-purple-400', card: 'text-yellow-600 dark:text-yellow-400' }

export default function PaymentMethodChart({ subscriptions }) {
  const total = subscriptions.length || 1

  const methodData = methods.map(method => ({
    method,
    count: subscriptions.filter(s => s.payment_method === method).length,
    amount: subscriptions.filter(s => s.payment_method === method).reduce((sum, s) => sum + Number(s.amount), 0),
  })).filter(m => m.count > 0)

  return (
    <div className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 p-6">
      <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold mb-6">Payment Methods</div>
      {methodData.length === 0 ? (
        <div className="text-gray-400 text-sm">No payment data yet</div>
      ) : (
        <div className="flex flex-col gap-4">
          {methodData.map(({ method, count }) => {
            const percentage = Math.round((count / total) * 100)
            return (
              <div key={method}>
                <div className="flex justify-between items-center mb-1">
                  <span className={`text-sm font-semibold ${textColors[method]}`}>{labels[method]}</span>
                  <span className="text-gray-500 text-xs">{count} payments ({percentage}%)</span>
                </div>
                <div className="bg-gray-200 dark:bg-white/10 h-2">
                  <div className={`${colors[method]} h-2 transition-all`} style={{ width: `${percentage}%` }} />
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}